import {
  Container,
  Row,
  Button,
  ButtonVariation,
  ButtonSize,
  MediaQuery,
  AdCard,
  Col
} from 'UI'
import Layout from 'components/common/Layout'
import CategoriesBar from 'components/Catalog/CategoriesBar'
import style from './style'
import { createUseStyles, useTheme } from 'react-jss'
import CatalogTitle from 'components/Catalog/CatalogTitle'
import Seo from './Seo'
import { useEffect } from 'react'
import { useParams } from 'react-router'
import CoursesGridNew from 'components/common/CoursesGridNew'
import FreeCoursesTagsBar from 'components/Catalog/FreeCoursesTagsBar'
import TagsBar from 'components/Catalog/TagsBar'
import { freeCoursesCategory } from 'components/Catalog/store'
import { CatalogLearningPathsPath, CourseNeutralPath } from 'navigation/Routes'
import Text from './text.json'
import { ExternalAlphormPages, allCoursesId } from 'constants/'
import { decorateUrl } from 'components/common/UTMscript'

const useStyle = createUseStyles(style)

export default ({
  selectCategoryFromSlug,
  selectedCategory,
  courses,
  loading,
  goToLink,
  seeMore,
  count
}) => {
  const theme = useTheme()
  const { categoryName } = useParams()
  useEffect(() => {
    selectCategoryFromSlug(categoryName)
  }, [categoryName])

  const showFreeCoursesTags = selectedCategory.Id === freeCoursesCategory.Id

  const { container, categoriesClass, tagsRow, rowContent } = useStyle()

  return (
    <Layout hideSupport>
      <Seo />
      <Container className={container}>
        <Row>
          <CatalogTitle />
        </Row>
        <Row className={rowContent}>
          <Col grid={3} mgrid={12} sgrid={12} className={categoriesClass}>
            <CategoriesBar />
            <MediaQuery ShowOnDesktop>
              <AdCard
                title={Text.learningPathCard.title}
                core={Text.learningPathCard.paragraph}
                buttonLabel={Text.learningPathCard.button}
                onButtonClick={() => goToLink(CatalogLearningPathsPath)}
                shadowColor={theme.extra.violet}
                secondary
                noFlex
                margin='8px 0 0 0'
                href={decorateUrl(CatalogLearningPathsPath)}
              />
              <AdCard
                title={Text.recommendNewCourses.title}
                core={Text.recommendNewCourses.paragraph}
                buttonLabel={Text.recommendNewCourses.button}
                onButtonClick={() => window.open(ExternalAlphormPages.NewCoursesIdeas, '_blank', 'noopener')}
                shadowColor={theme.secondary[0]}
                noFlex
                margin='16px 0 0 0'
                href={decorateUrl(ExternalAlphormPages.NewCoursesIdeas)}
              />
            </MediaQuery>
          </Col>
          <Col grid={9} mgrid={12} sgrid={12}>
            {
              selectedCategory.Id === allCoursesId
                ? null
                : (
                  <div className={tagsRow}>
                    <MediaQuery ShowOnDesktop>
                      {showFreeCoursesTags ? <FreeCoursesTagsBar /> : <TagsBar />}
                    </MediaQuery>
                    <MediaQuery HideOnDesktop>
                      {showFreeCoursesTags ? <FreeCoursesTagsBar selectList /> : <TagsBar selectList />}
                    </MediaQuery>
                  </div>
                  )
            }
            <CoursesGridNew
              loading={loading}
              loadingCount={9}
              courses={courses}
              columnGap={43}
              columnDesktopGap={43}
              tabletColumnGap={24}
              mobileColumnGap={0}
              rowGap={24}
              rowDesktopGap={24}
              tabletRowGap={16}
              mobileRowGap={16}
              columnCount={3}
              columnDesktopCount={2}
              tabletColumnCount={2}
              mobileColumnCount={1}
              containerMarginBottom={32}
              containerMarginBottomTablet={24}
              containerMarginBottomMobile={24}
              showLoadingMore
              handleCardClick={(course) => goToLink(`${CourseNeutralPath}/${course.Slug}`)}
            />
            {
              count > courses.length
                ? (
                  <Row justify='center'>
                    <Col grid={12} mgrid={12} sgrid={12}>
                      <Button
                        variation={ButtonVariation.text}
                        size={ButtonSize.small}
                        label={Text.showMore}
                        onHandleClick={seeMore}
                        marginButtonTablet='0 0 32px 0'
                        marginButtonMobile='0 0 32px 0'
                      />
                    </Col>
                  </Row>
                  )
                : null
            }
          </Col>
        </Row>
        <MediaQuery HideOnDesktop>
          <AdCard
            title={Text.learningPathCard.title}
            core={Text.learningPathCard.paragraph}
            buttonLabel={Text.learningPathCard.button}
            onButtonClick={() => goToLink(CatalogLearningPathsPath)}
            shadowColor={theme.extra.violet}
            secondary
            noFlex
            margin='0 0 32px 0'
            tabletMargin='0 0 32px 0'
            mobileMargin='0 0 32px 0'
            href={decorateUrl(CatalogLearningPathsPath)}
          />
          <AdCard
            title={Text.recommendNewCourses.title}
            core={Text.recommendNewCourses.paragraph}
            buttonLabel={Text.recommendNewCourses.button}
            onButtonClick={() => window.open(ExternalAlphormPages.NewCoursesIdeas, '_blank', 'noopener')}
            shadowColor={theme.secondary[0]}
            noFlex
            href={decorateUrl(ExternalAlphormPages.NewCoursesIdeas)}
            margin='0 0 32px 0'
            tabletMargin='0 0 32px 0'
            mobileMargin='0 0 32px 0'
          />
        </MediaQuery>
      </Container>
    </Layout>
  )
}
